import React, { useState, useEffect } from 'react'
import { Combo } from 'components'
import { fetchUrl } from 'modules/util/functions'

const ProteccionesCombo = (props) => {
	const [items, setItems] = useState([]);

	useEffect(() => {
		fetchUrl("/query/getProtecciones", "get", {}, {
			success: (r) => {
				let items = r.data.protecciones.map(x => ({
					value: x.idProteccion,
					label: x.nombre
				}));

				if (props.exclusions)
					items = items.filter(x => !props.exclusions.includes(x.value.toString()));

				setItems(items);
			}
		}, { block: false });
	}, [props.exclusions]);

	return (
		<Combo
			{...props}
			items={items} />
	)
}

export default ProteccionesCombo;

ProteccionesCombo.defaultProps = {
	formControl: true,
	formManaged: false
};